import { render, staticRenderFns } from "./CounterByCountry.vue?vue&type=template&id=4d1a33ac&scoped=true&"
import script from "./CounterByCountry.vue?vue&type=script&lang=js&"
export * from "./CounterByCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a33ac",
  null
  
)

export default component.exports